export function getLoginCodeErrorMessage(code: string) {
  const errorMessageMap = {
    100001: 'ACORPW_ERROR',
    100004: 'VERIFY_CODE_ERR',
    100005: 'GET_VERIfY_CODE_TOO_FAST',
    100006: 'VERIFY_CODE_ERR2',
    20: 'LOGIN_EXCEPTION',
  } as Record<string, string>

  return errorMessageMap[code] ?? ''
}
